/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar9(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M11.5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5Z" opacity=".3"/><path d="M11.5 9C9.6 9 8 7.4 8 5.5S9.6 2 11.5 2 15 3.6 15 5.5 13.4 9 11.5 9zm0-5c-.8 0-1.5.7-1.5 1.5S10.7 7 11.5 7 13 6.3 13 5.5 12.3 4 11.5 4zM16 23c-4.5 0-7.6-2.1-8.8-6H4v-4c0-1.7 1.3-3 3-3h9c1.7 0 3 1.3 3 3v4h-2.9c.1 1.1.8 2.6 3.3 3.6l2.1.8-2.1 1c-1 .5-2.4.6-3.4.6zM6 15h2.8l.2.8c.8 3.5 3.1 5.2 7 5.2h.1c-1.2-1.1-2.2-2.7-2.1-5v-1h3v-2c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v2z"/><path d="M5 16v-3c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v3h-3c0 1 0 4 4 5.5-1 .5-2.5.5-3 .5-4.3 0-7.1-2-8-6H5z" opacity=".3"/></svg>
  );
}

export default Avatar_icn_avatar9;
